import { Components, Theme } from "@mui/material";

export const MuiTabs: Components<Theme>["MuiTabs"] = {
  styleOverrides: {
    root: {
      ".MuiTab-root": {
        textTransform: "none",
        letterSpacing: "0.4px",
      },
    },
  },
};
